@let _disabled = disabled();

<formly-form [style.width.%]="100"
             [style.pointer-events]="_disabled ? 'none' : 'all'"
             [style.opacity]="_disabled ? 0.5 : 1"
             [form]="$any(form)"
             [fields]="fields()"
             [(model)]="model"
             (modelChange)="modelChanged($event)"></formly-form>
